import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { CARDS_ROUTE_PATHS } from '../config';

export const DEBIT_CARD_OPERATIONS_ROUTES: TApplicationRoute[] = [
  {
    id: 'cards-debit-card-operations',
    path: CARDS_ROUTE_PATHS.debitCardOperations,
    component: lazy(() => import('./pages/debit-card-operations-page')),
    layout: 'default',
    permissions: { roles: [], scopes: ['debit-card-operations'] },
    menu: {
      title: 'Debit Card Operations',
    },
  },
];
